
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class Loader extends Vue {
  logoName = 'Angel Quiz';
}
